import { Ring } from '@core/utils/geo-polygon.utils';

/**
 * How many vertices the user has actually placed in a ring mapbox-gl-draw is still
 * collecting.
 *
 * While `draw_polygon` runs, Draw keeps one extra vertex under the cursor and closes the
 * ring for `toGeoJSON`, so the exterior ring always carries two positions the user has not
 * committed. Knowing the real count is what lets Done close the ring itself instead of
 * requiring the enter key.
 */
export function placedVertexCount(ring: Ring): number {
  return Math.max(0, ring.length - 2);
}

/**
 * The vertex index a mapbox-gl-draw `coord_path` addresses, or null when it points
 * somewhere this editor must not touch.
 *
 * Draw writes `"<ring>.<vertex>"` onto every vertex feature it renders. Only the exterior
 * ring is editable here — Draw cannot author interior rings, so a hole's vertices are
 * carried through untouched rather than deleted out from under the geometry that owns them.
 */
export function outerRingVertexIndex(coordPath: unknown): number | null {
  if (typeof coordPath !== 'string') {
    return null;
  }

  const parts = coordPath.split('.');
  if (parts.length !== 2 || parts[0] !== '0') {
    return null;
  }

  const index = Number(parts[1]);
  return Number.isInteger(index) && index >= 0 ? index : null;
}
